export const formatPrice = (value: string | number) =>
  typeof value === 'string' ? value : String(value / 100);

export const formatNumberPrice = (value: number = 0) => value / 100;
